import {ComponentsConfigs, Game, GameParameters} from '@gongxigames/framework/core';
import {slotComponentsConfigV2} from '@gongxigames/framework/slot/configs/components/slotComponentsConfigV2';
import {integrationComponentsConfig} from '@gongxigames/framework/integrations/integrationComponentsConfig';
import {slotComponentsConfig} from './configs/components/slotComponentsConfig';
import {getProviderComponents, getProviderUIComponents} from '@gongxigames/framework/slot/configs/components/providerComponentsMap';
import {GameConfig} from '@gongxigames/framework/slot/types';
/* develblock:start */
import {slotStore} from '@gongxigames/framework/slotV2/globals';
/* develblock:end */

type SlotParameters = Omit<GameParameters, 'environmentProperty' | 'componentsConfig'> & {
    componentsConfig: ComponentsConfigs;
};

export function runSlot({componentsConfig: gameComponentsConfig, ...parameters}: SlotParameters): Game {
    const gameProvider = (parameters.gameConfig as GameConfig).gameProvider;
    const isStateMachine = Boolean(parameters.stateMachineConfig);

    const game = Game.run({
        ...parameters,
        componentsConfig: [
            getProviderUIComponents(isStateMachine, gameProvider),
            isStateMachine ? slotComponentsConfigV2 : slotComponentsConfig,
            getProviderComponents(isStateMachine, gameProvider),
            integrationComponentsConfig,
            gameComponentsConfig
        ],
        environmentProperty: window.RP_CONFIG
    });

    /* develblock:start */
    (window as any).game = game;
    (window as any).slotStore = slotStore;
    /* develblock:end */

    return game;
}
